import React from "react";
import useSettings from "../hooks/useSettings";
const Base = ({ children, hideLinks }) => {
  const settings = useSettings();
  return (
    <div>
      <header>
        <div className="sb-base-header">
          <div className="sb-flex sb-items-center">
            <div className="sb-client-logo">
              <a href="/configurable-products">
                <img
                  src={settings.customerLogo}
                  style={{ maxWidth: "100px" }}
                />
              </a>
            </div>
            <div>
              <div>
                <h5>{settings.customerDisplayName} Configurator</h5>
              </div>
              <div>
                <small style={{ height: "1.5em", display: "block" }}>
                  Server Configurator powered by&nbsp;
                  <img
                    src="/assets/imgs/od.png"
                    style={{
                      height: "100%",
                      width: "auto",
                      display: "inline-block",
                    }}
                  />
                </small>
              </div>
            </div>
            <div
              style={{
                flexGrow: 1,
                padding: "15px",
                justifyContent: "end",
                gap: "20px",
                fontWeight: "bold",
                color: "#fd6630 !important",
                display: hideLinks ? "none" : "flex",
              }}
            >
              <div>
                <a href="/configurable-products" style={{ color: "#fd6630" }}>
                  Configure
                </a>
              </div>
              <div>
                <a href="/quotes" style={{ color: "#fd6630" }}>
                  Quotes
                </a>
              </div>
              <div>
                <a href="/logout" style={{ color: "#fd6630" }}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer>
        <div
          className="sb-base-header"
          style={{ marginBottom: 0, marginTop: "20px", textAlign: "center" }}
        >
          <div className="sb-flex sb-items-center">
            <div>
              <div>{/* <h5>MLP Configurator</h5> */}</div>
              <div>
                <small style={{ height: "1.5em", display: "block" }}>
                  Server Configurator powered by&nbsp;
                  <img
                    src="/assets/imgs/od.png"
                    style={{
                      height: "100%",
                      width: "auto",
                      display: "inline-block",
                    }}
                  />
                </small>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Base;
